<template>
    <span v-if="errors && errors.length">
        <ul>
            <li class="argon-error" v-for="error in errors" :key="error.fila">
            Fila {{ error.fila }}: {{ error.error }}
            </li>
        </ul>
    </span>
</template>
  
<script>
    export default {
        name: "validation-errors",
        props: {
        errors: {
            type: Array,
            default: () => ([])
        }
        }
    }
</script>

<style lang="scss">
    .argon-error {
        position: relative;
        bottom: 25px;
        color: #fb6340;
    }

</style>
